import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps, setRef } from '@sheerid/jslib';

const CaptainsCircleComponent = ({ value, isErrored, onChange, placeholder = '', errorId }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-captains-circle">
            <div className="sid-l-space-top-md" />
                <label htmlFor="sid-captains-circle">
                    <div className={`sid-field__label sid-l-space-btm-sm
                                    ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                        <FormattedHTMLMessage
                            id="captainsCircleNumber"
                            defaultMessage="Captains Circle Number (CCN)"
                        />
                    </div>
                </label>
                <input
                    className={
                        `sid-text-input sid-text-input--required
                            sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                    }
                    id="sid-captains-circle"
                    name="sid-captains-circle"
                    aria-label={'Captains Circle Number'}
                    aria-required={false}
                    aria-describedby={`captainsCircleExplanation ${isErrored ? 'invalidCaptainsNumber' : ''}`}
                    type="text"
                    maxLength={10}
                    minLength={9}
                    pattern="[a-zA-Z0-9]*"
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                    placeholder={placeholder}
                    ref={(input: any) => setRef('captainsCircleNumber', input as HTMLInputElement)}
                />
                {
                    isErrored && (
                            <div className="sid-field-error" id={`${errorId}`}>
                                <FormattedHTMLMessage
                                    id={`errorId.${errorId}`}
                                    defaultMessage="Missing Captains Circle Number"
                                />
                            </div>
                    )
                }

                <div className="sid-field-captains-circle-explanation" id="captainsCircleExplanation">
                    <FormattedHTMLMessage
                        id="captainsCircleExplanation"
                        defaultMessage={
                            `If you do not have a Captains Circle Number, please
                            <a href="https://book.princess.com/captaincircle/showRegistration.page?popupCondition=register-button-click">
                            click here to register with Princess</a>. You must be
                            registered with Princess Cruises in order to verify
                            your military status and receive our military benefit.`
                        } />
                </div>

        </div>
    );
};

export { CaptainsCircleComponent };
